module.exports = __webpack_public_path__ + "img/pangao_pic3.66150025.png";